(function (jQuery) {
    return jQuery.widget("IKS.cleanText", {
        options: {
            editable: null,
            uuid: "",
            link: false,
            image: false,
            dialogOpts: null,
            buttonCssClass: null,
            maxChar: 48
        },
        _create: function () {
            var _this = this;
            $(_this.options.editable.element).keydown(function (e) {
                var keys = [
                    8, 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 144, 145
                ];

                if ($.inArray(e.keyCode, keys) == -1) {
                    if ($(_this.options.editable.element).text().length >= _this.options.maxChar) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
            });

            $(_this.options.editable.element).on("paste", function (e) {
                setTimeout(function () {
                    if ($(e.target).text().length > _this.options.maxChar) {
                        $(e.target).text($(e.target).text().substring(0, _this.options.maxChar));
                    }
                }, 100);
            });
        },
        populateToolbar: function (toolbar) {},
        cleanupContentClone: function (element) {
            var _this = this;
        }
    });
})(jQuery);
